import React from "react";
import { TextField } from "@mui/material";

// Standardized filter/search input. Variant + size come from the theme defaults
// (outlined, small) so every search box across the app looks and spaces the same.
const SearchField = ({ label, value, onChange, ...rest }) => (
  <TextField
    type="text"
    label={label}
    value={value}
    onChange={onChange}
    fullWidth
    {...rest}
  />
);

export default SearchField;
